import { ReactComponent as LeftArrowIcon } from '@quick/components/assets/left-arrow.svg';

export interface BackButtonProps {
  onClick?: () => void;
  text: string;
  autoFocus?: boolean;
}

function BackButton({ text = 'Volver', onClick, autoFocus }: BackButtonProps) {
  return (
    <button
      className="group flex items-center gap-2 focus:outline-none"
      onClick={onClick}
      autoFocus={autoFocus}
    >
      <div className="group-focus:ring-brand flex h-12 w-12 items-center justify-center rounded-full border-2 border-gray-200 bg-white text-black group-focus:ring dark:bg-black dark:text-gray-200">
        <LeftArrowIcon />
      </div>
      <span className="font-semibold group-focus:underline dark:text-gray-200">
        {text}
      </span>
    </button>
  );
}

BackButton.displayName = 'BackButton';

export { BackButton };
